module.exports = __webpack_public_path__ + "static/media/trip-report 1.43788a4d.png";